<template>
    <div>
        <b-breadcrumb :items="items"></b-breadcrumb>
        <div>
            <b-navbar toggleable="md" type="light" variant="light">
                <b-navbar-toggle target="search_nav_collapse"></b-navbar-toggle>
                <b-collapse is-nav id="search_nav_collapse">
                    <b-navbar-nav>
                        <b-nav-item class="item margin"
                                    :class="profileActive()"
                                    @click="goToProfile">
                            ชื่อ-สกุล
                        </b-nav-item>
                        <b-nav-item class="item margin"
                                    @click="goToSalary"
                                    :class="salaryActive()">
                            เงินเดือน
                        </b-nav-item>
                        <b-nav-item class="item margin"
                                    @click="goToQuarantor"
                                    :class="quaranteeActive()">
                            เงินค้ำประกัน
                        </b-nav-item>
                        <b-nav-item class="item margin"
                                    @click="goToSocialInsurance"
                                    :class="socialInsuranceActive()">
                            ประกันสังคม
                        </b-nav-item>
                        <b-nav-item class="item margin"
                                    @click="goToLeaveDay"
                                    :class="leaveDayActive()">
                            สิทธิ์การลา
                        </b-nav-item>
                        <b-nav-item class="item margin"
                                    @click="goToTax"
                                    :class="taxActive()">
                            ภาษีเงินได้
                        </b-nav-item>
                        <b-nav-item class="item margin"
                                    :class="cardActive()"
                                    router-link to="/hr/employee-information/card_employee">
                            บัตรพนักงาน
                        </b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            <div>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import EmployeeData from "./EmployeeData";
    import EmployeeSalary from "./EmployeeSalary";
    import EmployeeQuarantee from "./EmployeeQuarantee";
    import EmployeeLeaveDay from "./EmployeeLeaveDay";
    import EmployeeTax from "./EmployeeTax";

    export default {
        components: {
            EmployeeTax,
            EmployeeLeaveDay,
            EmployeeQuarantee,
            EmployeeSalary,
            EmployeeData},
        name : "employee-information",
        data(){
            return {
                items: [
                    {
                        text: 'รายการพนักงาน',
                        to: {name:"employee"}
                    },
                    {
                        text: 'เพิ่มเติม',
                        active: true
                    }
                ]
            }
        },
        methods:{
            goToProfile(){
                this.$router.push({
                    name : "employee-information-profile",
                    params : { status_bar : true }
                })
            },
            goToSalary(){
                this.$router.push({
                    name: "employee-information-salary",
                    params: { status_bar : true }
                });
            },
            goToQuarantor(){
                this.$router.push({
                    name: "employee-information-quarantee",
                    params: { status_bar : true }
                });
            },
            goToLeaveDay(){
                this.$router.push({
                    name: "employee-information-leaveDay",
                    params: { status_bar : true }
                });
            },
            goToTax(){
                this.$router.push({
                    name: "employee-information-tax",
                    params: { status_bar : true }
                });
            },
            /*add 5/5/2020*/
            goToSocialInsurance(){
                this.$router.push({
                    name: "employee-social-insurance",
                    params: { status_bar : true }
                })
            },
            /*add 5/5/2020*/
            socialInsuranceActive(){
                return {
                    active:
                    this.$route.path === "/hr/employee-information/insurance"
                }
            },
            profileActive(){
                return {
                    active:
                    this.$route.path === "/hr/employee-information/profile" ||
                    this.$route.path === "/hr/employee-information"
                }
            },
            salaryActive(){
                return {
                    active:
                    this.$route.path === "/hr/employee-information/salary"
                }
            },
            quaranteeActive(){
                return {
                    active:
                    this.$route.path === "/hr/employee-information/quarantee"
                }
            },
            leaveDayActive(){
                return {
                    active:
                    this.$route.path === "/hr/employee-information/leaveDay"
                }
            },
            taxActive(){
                return {
                    active:
                    this.$route.path === "/hr/employee-information/tax"
                }
            },
            cardActive(){
                return {
                    active:
                    this.$route.path === "/hr/employee-information/card_employee"
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .navbar-light .navbar-nav .show > .nav-link,
    .navbar-light .navbar-nav .active > .nav-link,
    .navbar-light .navbar-nav .nav-link.show,
    .navbar-light .navbar-nav .nav-link.active {
        background-color: yellow;
        color: black;
    }
    .navbar-nav .nav-link {
        color: black;
    }
</style>